// ============================================================
// One stream (v8.363.1): the combat log and the vox merged by time at
// render, so the narrative's allow-list is never touched. Stable: on a
// tie the log line comes first. The viewer's lanes (engine/log/lanes,
// v9.7.0; the Talk filter before it) say which kinds of line are kept. Pure.
// ============================================================
import type { NarrativeEntry } from '../../types';
import type { ChatMessage } from './types';
import { inLanes, type Lane } from '../log/lanes';

export type LogItem =
  { kind: 'narrative'; entry: NarrativeEntry; ts: number } | { kind: 'chat'; msg: ChatMessage; ts: number };

/** Every line of both streams, by time. `hidden` are the lanes the viewer switched off. */
export function mergeLogItems(
  narrative: NarrativeEntry[],
  chat: ChatMessage[],
  hidden: readonly Lane[] = [],
): LogItem[] {
  const items: LogItem[] = [];
  for (const entry of narrative) items.push({ kind: 'narrative', entry, ts: entry.timestamp });
  for (const msg of chat) items.push({ kind: 'chat', msg, ts: msg.ts });
  // A stable sort: equal timestamps keep insertion order, log before vox.
  const merged = items
    .map((item, i) => ({ item, i }))
    .sort((a, b) => a.item.ts - b.item.ts || a.i - b.i)
    .map(({ item }) => item);
  return inLanes(merged, hidden);
}
